import React, { useState, useEffect } from 'react';
import Service from "src/api/Service";
import colorPalette from "src/assets/js/colorPalette";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';


ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);


export default function MultiType(props) {



  const [showLegends, setShowLegends] = useState(false);
  const [Bar, setBar] = useState([]);
  const [week, setWeek] = useState([]);
  const [sumD, setsumD] = useState([]);
  const [dataS, setdataS] = useState([]);
  const [labelData, setlabelData] = useState([]);
  const [isLoading, setisLoading] = useState(true);

  function getData(){
  
     var data= {
      "fieldsToShow": {
          "idx": {
              "sTitle": "Index"
          },
          "status_name": {
              "sTitle": "Status \/ Week"
          },
          "week": {
              "sTitle": "Week \/ Sum"
          },
          "sum": {
              "sTitle": " Receipt \/ Inventory"
          }
      },
      "data": [
          {
              "idx": "1",
              "week": "W1",
              "status_name": "Goods from Port to W\/H",
              "sum": "20.00"
          },
          {
              "idx": "1",
              "week": "W2",
              "status_name": "Goods from Port to W\/H",
              "sum": "40.00"
          },
          {
              "idx": "1",
              "week": "W3",
              "status_name": "Goods at Port",
              "sum": "35.00"
          },
          {
              "idx": "1",
              "week": "W4",
              "status_name": "Goods in High Seas",
              "sum": "60.00"
          },
          {
              "idx": "1",
              "week": "W5",
              "status_name": "Goods in High Seas",
              "sum": "30.00"
          },
          {
              "idx": "1",
              "week": "W6",
              "status_name": "Goods in High Seas",
              "sum": "10.00"
          },
          {
              "idx": "3",
              "week": "W1",
              "status_name": "20.00",
              "sum": "30.00"
          },
          {
              "idx": "3",
              "week": "W2",
              "status_name": "60.00",
              "sum": "10.00"
          },
          {
              "idx": "3",
              "week": "W3",
              "status_name": "95.00",
              "sum": "-5.00"
          },
          {
              "idx": "3",
              "week": "W4",
              "status_name": "155.00",
              "sum": "5.00"
          },
          {
              "idx": "3",
              "week": "W5",
              "status_name": "185.00",
              "sum": "35.00"
          },
          {
              "idx": "3",
              "week": "W6",
              "status_name": "195.00",
              "sum": "45.00"
          }
      ],
      "table_title": "Inventory"
  }
    
        var label=[];
        var dataSet=[];
        console.log("MultiType");
        console.log(data['data']);
      let obj = data['data'].reduce((res, curr) =>{
          if (res[curr.idx]) {
            res[curr.idx].push(curr);
          }          
          else{
            Object.assign(res, {[curr.idx]: [curr]});
          }             

          return res;
      }, {});
 

       var label=[];
       var barData=[];
       var week=[];
       var sumD=[];

            //status_name

      obj[1].map(item=>{
        label.push(item['week']);
        barData.push(item['sum']);
      })
       var LineValue=[];
       obj[3].map(item=>{
        LineValue[item['week']]=[];
           var data={'status_name':item['status_name'],'sum':item['sum']}
           LineValue[item['week']].push(data);
       
        })

        
      label.map(item=>{

         week.push(LineValue[item][0]['status_name']);
            sumD.push(LineValue[item][0]['sum']);
      });
       setlabelData(label);
       setBar(barData);
       setWeek(week);
       setsumD(sumD);
       setisLoading(false);
    
  
  }
  useEffect(() => {
    getData();
  },[]);



  // if(isLoading){
  //   return (<>...</>);
  // }


  const data = {
    labels:labelData,
    datasets: [
      {
        type: 'line',
        label: 'Cumulative Receipt',
        borderColor: "#36A2EB",
        backgroundColor:  "#36A2EB",
        borderWidth: 2,
        // fill: false,
        data: week,
        yAxisID: 'y1',
      },

      {
        type: 'line' ,
        label: 'Cumulative Projected Inventory',
        backgroundColor:  "#9966FF",
        borderColor: "#9966FF",
        data: sumD,
        yAxisID: 'y1',
      },
      {
        type: 'bar' ,
        label: 'Week-wise Receipt',
        backgroundColor: "#FF9F40",
        data: Bar,
        borderColor: 'white',
        borderWidth: 2,
        // yAxisID: 'y',
      },

    ],
  };
  var options = {
    tooltips: {
      enabled: true,
      backgroundColor: {
        color: '#FF0000',
        opacity: 0.5,
      },
    },
    scales: {
      y: {
        type: 'linear',
        display: true,
        position: 'left',
      },
      y1: {
        type: 'linear',
        display: true,
        position: 'right',

        // grid line settings
        grid: {
          drawOnChartArea: false, // only want the grid lines for one axis to show up
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',       
        align:'left',
        fullSize:true,
        labels:{
          boxWidth:10,
          textAlign:'left',
          font: {
            size: 10
          }
        }
      },
      datalabels: {
        formatter: (value, ctx) => {
  
          let sum = ctx.dataset._meta[0].total;
          let percentage = (value * 100 / sum).toFixed(2) + "%";
          return percentage;
  
  
        },
        color: '#fff',
      }
    }
  };
  return  <>
  <div className='row'>
<div className='col-lg-7'>
 <div className='componentNameC'>{"Projected Inventory"}</div>
</div>
</div>


<div className='p-4'>
<Chart type='bar' data={data} options={options} />
</div>
</>
}
